module.exports = __webpack_public_path__ + "static/media/diners.9a4579a2.svg";